import Sentry from "@similarweb/sentry-logger";

export const NO_VOID_FUNCTIONS = "Void function can't be part of the functions array";

export const pipe =
    (...functions: Array<(arg: any) => any>) =>
    (initialArg: any) =>
        functions.reduce((prevOutput: any, func) => {
            if (!prevOutput) {
                Sentry.error("error in pipe.ts", new Error(NO_VOID_FUNCTIONS));
            } else {
                return func(prevOutput);
            }
        }, initialArg);
